import React from "react";

interface RillDashboardProps {
  iframeSrc: string;
  title?: string;
  height?: string | number;
  width?: string | number;
  className?: string;
  style?: React.CSSProperties;
}

const RillDashboard: React.FC<RillDashboardProps> = ({
  iframeSrc,
  title = "Rill Dashboard",
  height = "1400px",
  width = "100%",
  className,
  style,
}) => {
  const containerStyle: React.CSSProperties = {
    position: "relative",
    width,
    height,
    overflow: "hidden",
    ...style,
  };

  const iframeStyle: React.CSSProperties = {
    width: "100%",
    height,
    border: "none",
    display: "block",
  };

  return (
    <div className={className} style={containerStyle}>
      <iframe
        src={iframeSrc}
        title={title}
        style={iframeStyle}
        allow="fullscreen"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
        scrolling="no"
      />
    </div>
  );
};

export default RillDashboard;
